// src/components/chemistry/Dropzone.jsx
import { useDrop } from "react-dnd";
import { ItemTypes } from "../../utils/constants";

export default function DropZone({ acceptType = "reagent", onDrop, label }) {
  // acceptType = "effect" → accept = ItemTypes.EFFECT ("EFFECT")
  const acceptKey = (acceptType || "reagent").toUpperCase();
  const accept = ItemTypes[acceptKey] || ItemTypes.REAGENT;

  const [{ isOver }, drop] = useDrop(
    () => ({
      accept, // MUST match dragType exactly
      drop: (item) => {
        if (item && onDrop) onDrop(item); // full item object
        return {};
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
      }),
    }),
    [accept, onDrop]
  );

  return (
    <div
      ref={drop}
      className={`flex flex-col items-center justify-center 
        w-56 sm:w-64 h-14 sm:h-16 
        border-2 border-dashed rounded-lg 
        transition-all duration-200 
        ${
          isOver
            ? "border-blue-500 bg-blue-50 scale-105"
            : "border-gray-300 bg-gray-100"
        }
      `}
    >
      <div className="text-xs sm:text-sm text-gray-600 text-center px-2">
        {label}
      </div>
    </div>
  );
}
